export default {
  getCycle(item) {
    const day = ~~item.min_days;
    let res;
    if (day === 0) { res = '0~1个工作日' }
    else if (day < 4) { res = `${day - 1}~${day}个工作日` }
    else if (day >= 4) { res = `${day - 2}~${day}个工作日` }
    else { res = '--' }
    return res;
  }
}